import { BankOutlined, UserOutlined, WalletOutlined } from "@ant-design/icons";
import { Avatar, Card, Dropdown, Menu, Space, Tag, Typography } from "antd";
import { useCallback, useEffect, useState } from "react";
import { WorkTimer } from "src/enitities/WorkTimer";
import { apiRequests } from "src/shared/api/api";
import { UpgradeSubscriptionModal } from "./UpgradeSubscriptionModal";

const { Text } = Typography;

export function CBSelect(props) {
  const [userData, setUserData] = useState(null);
  const [isUpgradeModalOpen, setIsUpgradeModalOpen] = useState(false);
  const [accountInfo, setAccountInfo] = useState(null);
  const index = props.CBData.findIndex((item) => props.token === item.token);
  const CurrentCB = props.CBData[index];

  const sub = [
    {
      label: "Кассы",
      key: "cboxes",
      icon: <WalletOutlined />,
      children: props.CBOptions,
    },
  ];

  const getUserData = useCallback(() => {
    apiRequests.users.getMyPermissions().then((permissionRes) => {
      const currentUserId = permissionRes.data.user_id;

      apiRequests.users.getItems().then((usersRes) => {
        const currentUser = usersRes.data.result.find(
          (user) => user.id === currentUserId
        );

        if (currentUser) {
          setUserData(currentUser);
        }
      });
    });
  }, []);

  useEffect(() => {
    getUserData();
  }, [getUserData]);

  const fetchAccountInfo = useCallback(() => {
    if (props.token) {
      apiRequests.setToken(props.token);
      apiRequests.account.getInfo({ params: {} })
        .then((response) => {
          setAccountInfo(response.data);
        })
        .catch((error) => {
          console.error('Ошибка при загрузке информации об аккаунте:', error);
        });
    }
  }, [props.token]);

  useEffect(() => {
    fetchAccountInfo();
  }, [fetchAccountInfo]);

  // Создаем меню для дропдауна
  const avatarMenu = (
    <Menu style={{ width: "fit-content" }}>
      <Menu.Item disabled>
        <Space
          style={{ width: "100%", justifyContent: "center", padding: "5px" }}
        >
          <Avatar
            size={60}
            src={`https://${process.env.REACT_APP_APP_URL}/${userData?.photo}`}
          />
        </Space>
        <Text
          strong
          style={{ fontSize: 16, display: "block", textAlign: "center" }}
        >
          {"Здравствуйте, "}
          {userData?.first_name || userData?.username || "Пользователь"}
        </Text>
      </Menu.Item>
      {userData?.shift_work_enabled && (
        <>
          <Menu.Divider />
          <Card
            style={{
              width: 320,
              borderRadius: 16,
              boxShadow: "0 4px 20px rgba(0, 0, 0, 0.08)",
              border: "1px solid #f0f0f0",
            }}
            bodyStyle={{ padding: 24 }}
          >
            {userData?.shift_work_enabled && <WorkTimer />}
          </Card>
        </>
      )}
    </Menu>
  );

  return (
    <>
      <Space>
        <Tag
          icon={<BankOutlined />}
          onClick={() => setIsUpgradeModalOpen(true)}
          style={{ 
            cursor: 'pointer',
            userSelect: 'none',
            margin: 0,
            padding: '4px 12px',
            fontSize: '14px',
            lineHeight: '22px'
          }}
        >
          Баланс аккаунта: <b>{CurrentCB.balance}</b>
          {accountInfo?.type && (
            <>
              {' '}
              {accountInfo.type === 'demo' && accountInfo.demo_left !== undefined && (
                <span> (Демо, осталось {Math.floor(accountInfo.demo_left / 86400)} дн.)</span>
              )}
              {accountInfo.type === 'blocked' && (
                <span> (Заблокирован)</span>
              )}
              {accountInfo.type === 'paid' && (
                <span> (Оплачен)</span>
              )}
            </>
          )}
          {' / '}
          <b>{CurrentCB.name}</b>
        </Tag>
      <Menu
        items={sub}
        selectedKeys={CurrentCB.name}
        mode="horizontal"
        style={{ display: "inline-block" }}
        triggerSubMenuAction="click"
        subMenuCloseDelay={0.1}
        subMenuOpenDelay={0.1}
      />
      {userData && (
        <Dropdown overlay={avatarMenu} trigger={["click"]}>
          <Avatar
            src={`https://${process.env.REACT_APP_APP_URL}/${userData?.photo}`}
            style={{ marginRight: 10, cursor: "pointer" }}
            size={40}
            icon={!userData?.photo && <UserOutlined />}
          />
        </Dropdown>
      )}
      </Space>
      
      <UpgradeSubscriptionModal 
        open={isUpgradeModalOpen}
        onCancel={() => setIsUpgradeModalOpen(false)}
        token={props.token}
      />
    </>
  );
}
